import React from 'react';
import { useTranslation } from 'react-i18next';
import SidePanel from '../../../../../components/menus/SidePanel/SidePanel';
import ModalHeader from '@wix/da-ds/pkg/modals/dsPresets/Modal/ModalHeader';
import SolidButton from '@wix/da-ds/pkg/Buttons/SolidButton';
import Flex from '@wix/da-ds/pkg/Flex';
import InputLabelText from '@wix/da-ds/pkg/formControls/lego/InputLabelText';
import LayoutRadioButton from '../../../../../components/lego/LayoutRadioButton';
import EditorLayoutGrid from '@wix/da-ds/pkg/Icons/24x24/EditorLayoutGrid';
import EditorLayoutTorpedo from '@wix/da-ds/pkg/Icons/24x24/EditorLayoutTorpedo';
import useSettingsState from './useSettingsState';
import { getCurrentUser, getExtensionOptions } from '../../../../../components/utils/tiptap';
import { ListItemRadioButton } from '@wix/da-ds/pkg/List/ListItem';
import NumericField from '../../../../../components/lego/NumericField';
import TextInput from '@wix/da-ds/pkg/formControls/dsPresets/TextInput';
import { addMissingProtocol, validateHref } from '../../../../../components/utils/validateHref';
import s from './Settings.scss';
const SettingsForm = ({ editor, onClose })=>{
    var _attrs_deviations;
    const { t } = useTranslation('editor');
    const closeSettings = ()=>{
        onClose(false);
    };
    const options = getExtensionOptions(editor, 'da-gallery');
    const attrs = editor.getAttributes('da-gallery');
    const { state, setGalleryLayout, setGalleryWidth, setGridItemWidth, setGridItemHeight, setLayoutSpacing, setTorpedoRowHeight, setItemCropping, setRowAlignment, updateLinkFor } = useSettingsState(editor);
    const currentUser = getCurrentUser(editor);
    const atLeastOneCanLink = (_attrs_deviations = attrs.deviations) === null || _attrs_deviations === void 0 ? void 0 : _attrs_deviations.some((d)=>{
        var _d_author;
        return ((_d_author = d.author) === null || _d_author === void 0 ? void 0 : _d_author.userId) === (currentUser === null || currentUser === void 0 ? void 0 : currentUser.userId);
    });
    var _options_formMaxWidth, _ref, _options_minWidth;
    return /*#__PURE__*/ React.createElement(SidePanel, {
        editor: editor,
        onRequestClose: closeSettings,
        header: /*#__PURE__*/ React.createElement(ModalHeader, {
            heading: t('ext.gallery.settings.title')
        }),
        footer: /*#__PURE__*/ React.createElement(SolidButton, {
            size: "medium",
            variant: "approval-green",
            onClick: closeSettings
        }, t('ext.gallery.settings.btn.done'))
    }, /*#__PURE__*/ React.createElement(Flex, {
        direction: "column",
        gap: 16
    }, /*#__PURE__*/ React.createElement("fieldset", {
        className: s['fieldset']
    }, /*#__PURE__*/ React.createElement(InputLabelText, {
        className: s['legend']
    }, t('ext.gallery.settings.container')), /*#__PURE__*/ React.createElement(NumericField, {
        label: t('ext.gallery.settings.container.width'),
        value: state.width,
        onChange: setGalleryWidth,
        maxValue: (_ref = (_options_formMaxWidth = options.formMaxWidth) !== null && _options_formMaxWidth !== void 0 ? _options_formMaxWidth : options.maxWidth) !== null && _ref !== void 0 ? _ref : 780,
        minValue: (_options_minWidth = options.minWidth) !== null && _options_minWidth !== void 0 ? _options_minWidth : 10,
        sliderStep: 1
    })), /*#__PURE__*/ React.createElement("fieldset", {
        className: s['fieldset'],
        role: "radiogroup"
    }, /*#__PURE__*/ React.createElement(InputLabelText, {
        className: s['legend']
    }, t('ext.gallery.settings.layout')), /*#__PURE__*/ React.createElement("div", {
        className: s['layout-radio-group']
    }, /*#__PURE__*/ React.createElement(LayoutRadioButton, {
        label: t('ext.gallery.settings.layout.grid'),
        value: 'grid',
        onChange: setGalleryLayout,
        checked: state.layout === 'grid',
        icon: EditorLayoutGrid
    }), /*#__PURE__*/ React.createElement(LayoutRadioButton, {
        label: t('ext.gallery.settings.layout.torpedo'),
        value: 'torpedo',
        onChange: setGalleryLayout,
        checked: state.layout === 'torpedo',
        icon: EditorLayoutTorpedo
    }))), state.layout === 'grid' && /*#__PURE__*/ React.createElement("fieldset", {
        className: s['fieldset']
    }, /*#__PURE__*/ React.createElement(InputLabelText, {
        className: s['legend']
    }, t('ext.gallery.settings.gridSettings')), /*#__PURE__*/ React.createElement(NumericField, {
        label: t('ext.gallery.settings.gridSettings.thumbWidth'),
        value: state.gridItemWidth,
        onChange: setGridItemWidth,
        minValue: 10,
        maxValue: 400,
        sliderStep: 10
    }), /*#__PURE__*/ React.createElement(NumericField, {
        label: t('ext.gallery.settings.gridSettings.thumbHeight'),
        value: state.gridItemHeight,
        onChange: setGridItemHeight,
        minValue: 10,
        maxValue: 400,
        sliderStep: 10
    }), /*#__PURE__*/ React.createElement(NumericField, {
        label: t('ext.gallery.settings.spacing'),
        value: state.layoutSpacing,
        onChange: setLayoutSpacing
    })), state.layout === 'torpedo' && /*#__PURE__*/ React.createElement("fieldset", {
        className: s['fieldset']
    }, /*#__PURE__*/ React.createElement(InputLabelText, {
        className: s['legend']
    }, t('ext.gallery.settings.masonrySettings')), /*#__PURE__*/ React.createElement(NumericField, {
        label: t('ext.gallery.settings.masonrySettings.rowHeight'),
        value: state.torpedoRowHeight,
        onChange: setTorpedoRowHeight,
        minValue: 10,
        maxValue: 400,
        sliderStep: 10
    }), /*#__PURE__*/ React.createElement(NumericField, {
        label: t('ext.gallery.settings.spacing'),
        value: state.layoutSpacing,
        onChange: setLayoutSpacing
    })), /*#__PURE__*/ React.createElement("fieldset", {
        className: s['fieldset'],
        role: "radiogroup"
    }, /*#__PURE__*/ React.createElement(InputLabelText, {
        className: s['legend']
    }, t('ext.gallery.settings.cropping')), /*#__PURE__*/ React.createElement(ListItemRadioButton, {
        compact: true,
        name: 'cropping',
        value: 'crop',
        label: t('ext.gallery.settings.cropping.crop'),
        onChange: setItemCropping,
        checked: state.itemCropping === 'crop'
    }), /*#__PURE__*/ React.createElement(ListItemRadioButton, {
        compact: true,
        name: 'cropping',
        value: 'fit',
        label: t('ext.gallery.settings.cropping.fit'),
        onChange: setItemCropping,
        checked: state.itemCropping === 'fit'
    })), /*#__PURE__*/ React.createElement("fieldset", {
        className: s['fieldset'],
        role: "radiogroup"
    }, /*#__PURE__*/ React.createElement(InputLabelText, {
        className: s['legend']
    }, t('ext.gallery.settings.blockalign')), /*#__PURE__*/ React.createElement(ListItemRadioButton, {
        compact: true,
        name: 'innerAlignment',
        value: 'left',
        label: t('ext.gallery.settings.blockalign.left'),
        onChange: setRowAlignment,
        checked: state.layoutRowAlignment === 'left'
    }), /*#__PURE__*/ React.createElement(ListItemRadioButton, {
        compact: true,
        name: 'innerAlignment',
        value: 'center',
        label: t('ext.gallery.settings.blockalign.center'),
        onChange: setRowAlignment,
        checked: state.layoutRowAlignment === 'center'
    }), /*#__PURE__*/ React.createElement(ListItemRadioButton, {
        compact: true,
        name: 'innerAlignment',
        value: 'right',
        label: t('ext.gallery.settings.blockalign.right'),
        onChange: setRowAlignment,
        checked: state.layoutRowAlignment === 'right'
    })), options.canLink && atLeastOneCanLink && /*#__PURE__*/ React.createElement("fieldset", {
        className: s['fieldset']
    }, /*#__PURE__*/ React.createElement(InputLabelText, {
        className: s['legend']
    }, t('ext.gallery.settings.links.heading')), /*#__PURE__*/ React.createElement("p", {
        className: s['links-subheading']
    }, t('ext.gallery.settings.links.subheading')), /*#__PURE__*/ React.createElement("div", {
        className: s['links']
    }, attrs.deviations.map((dev, i)=>{
        var _dev_author, _state_linkOverrides, _state_linkOverrides1;
        const allowLink = ((_dev_author = dev.author) === null || _dev_author === void 0 ? void 0 : _dev_author.userId) === (currentUser === null || currentUser === void 0 ? void 0 : currentUser.userId);
        if (!allowLink) {
            return null;
        }
        var _state_linkOverrides_dev_deviationId, _state_linkOverrides_dev_deviationId1;
        return /*#__PURE__*/ React.createElement("div", {
            key: dev.deviationId
        }, /*#__PURE__*/ React.createElement(TextInput, {
            id: dev.deviationId,
            label: `Item ${i + 1}`,
            value: (_state_linkOverrides_dev_deviationId = state.linkOverrides[dev.deviationId]) !== null && _state_linkOverrides_dev_deviationId !== void 0 ? _state_linkOverrides_dev_deviationId : '',
            onChange: (e)=>updateLinkFor(dev.deviationId, e.target.value),
            placeholder: t('ext.gallery.settings.links.placeholder'),
            validationResult: ((_state_linkOverrides_dev_deviationId1 = (_state_linkOverrides = state.linkOverrides) === null || _state_linkOverrides === void 0 ? void 0 : _state_linkOverrides[dev.deviationId]) !== null && _state_linkOverrides_dev_deviationId1 !== void 0 ? _state_linkOverrides_dev_deviationId1 : '') === '' ? undefined : validateHref(addMissingProtocol((_state_linkOverrides1 = state.linkOverrides) === null || _state_linkOverrides1 === void 0 ? void 0 : _state_linkOverrides1[dev.deviationId])) ? 'success' : 'error',
            onFocus: (e)=>{
                setTimeout(()=>{
                    e.target.scrollIntoView();
                }, 300);
            }
        }));
    })))));
};
SettingsForm.displayName = 'SettingsForm';
export default SettingsForm;

//# sourceMappingURL=SettingsForm.js.map